/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class CostOptimizationCloudAccTypeResponse {
    getFixupPrototypeFunction() { return CostOptimizationCloudAccTypeResponse.fixupPrototype; }

    static newInstance(model: Partial<CostOptimizationCloudAccTypeResponse>): CostOptimizationCloudAccTypeResponse {
        let obj = Object.assign(new CostOptimizationCloudAccTypeResponse(), model);
        CostOptimizationCloudAccTypeResponse.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<CostOptimizationCloudAccTypeResponse>): CostOptimizationCloudAccTypeResponse {
        if (!model) return null;
        return CostOptimizationCloudAccTypeResponse.newInstance(<CostOptimizationCloudAccTypeResponse> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: CostOptimizationCloudAccTypeResponse) {
        if (!obj) return;

        models.CostOptimizationCloudAccTypeResponse.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: CostOptimizationCloudAccTypeResponse): boolean {
        Object.setPrototypeOf(obj, CostOptimizationCloudAccTypeResponse.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
    }

    /**
     * Response status on cloud account types
     */
    status: string;

    /**
     * Listing Cloud account types retrieved successfully
     */
    message: string;

    /**
     * cloud account type and cloud account name
     */
    data: any;

}
